// extracted by mini-css-extract-plugin
module.exports = {"invalidField":"EmailForm_invalidField__1wcy3","content":"EmailForm_content__OriYc","text":"EmailForm_text__3UBlJ"};